import { NbJSThemeOptions } from '@nebular/theme';
import { DEFAULT_THEME } from './theme.default';

export const CF_THEME = {
  name: 'cf_default',
  base: 'default',
  // We could override this in the future
  variables: DEFAULT_THEME.variables,
} as NbJSThemeOptions;
